export const ContactUs = () => {
    return (
        <div className="p-8">
            <div className="text-2xl font-bold mb-8">Contact Us</div>
            <div className="grid">
                Coming soon
            </div>
        </div>
    )
}